import { render } from "./UpdateUserRole.vue?vue&type=template&id=fe2f89ec"
import script from "./UpdateUserRole.vue?vue&type=script&lang=js"
export * from "./UpdateUserRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__